module.exports = __webpack_public_path__ + "static/img/027.ffc9b15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/027.png
// module id = C/Ay
// module chunks = 0